import Vue from "vue";
import PortalVue from 'portal-vue'

Vue.use(PortalVue)


// WEBPACK FOOTER //
// ./src/plugins/portal.js